import { useSyncExternalStore } from "react";

// 글쓰기 오른쪽 미리보기: 편집기(FgPostEditor)가 쓰는 중인 글을 두고, 미리보기(FdPostPreview)가 읽는다
let draft = null;
const listeners = new Set();

export function setPostPreviewDraft(next) {
    draft = next;
    listeners.forEach(listener => listener());
}

const subscribe = (listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
};

export function usePostPreviewDraft() {
    return useSyncExternalStore(subscribe, () => draft);
}

/** 미리보기에서 누른 모듈의 편집기로: 스크롤 + 잠깐 테두리 + 텍스트면 커서(글 끝), 이미지면 첫 버튼에 포커스 */
export function focusPostModule(key) {
    const card = document.querySelector(`[data-post-module="${key}"]`);
    if (!card) {
        return;
    }
    card.scrollIntoView({ behavior: 'smooth', block: 'center' });
    card.setAttribute('data-flash', '');
    setTimeout(() => card.removeAttribute('data-flash'), 1200);

    const prose = card.querySelector('.ProseMirror');
    if (prose?.editor) {
        prose.editor.commands.focus('end', { scrollIntoView: false }); // Tiptap 이 편집기 DOM 에 editor 를 달아 둔다
    } else {
        card.querySelector('button[aria-pressed]')?.focus({ preventScroll: true });
    }
}
